module.exports = __webpack_public_path__ + "assets/RetinaNarr-BlackItalic.bd6b56b4f156e702e5b29cfcaf1c71b6.woff2";